<script setup>
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>
<template>
  <div class="section-container">
    <div class="relative z-10 flex flex-col justify-center items-start w-full text-left h-full">
      <!-- Title -->
      <h2 class="text-4xl md:text-5xl text-center mb-16">{{ t("Onze Werkwijze") }}</h2>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-12 text-center md:text-left">
        <!-- Column 1 -->
        <div>
          <h3 class="text-lg md:text-xl font-bold mb-2">{{ t("Intake") }}</h3>
          <p
            class="text-gray-700"
          >{{ t("Grondige inventarisatie van uw specifieke personeelsbehoefte en organisatiecultuur voor een perfecte match.") }}</p>
        </div>
        <!-- Column 2 -->
        <div>
          <h3 class="text-lg md:text-xl font-bold mb-2">{{ t("Matching & Introductie") }}</h3>
          <p
            class="text-gray-700"
          >{{ t("Zorgvuldige selectie van geschikte kandidaten uit ons netwerk, gevolgd door een persoonlijke kennismaking.") }}</p>
        </div>
        <!-- Column 3 -->
        <div>
          <h3 class="text-lg md:text-xl font-bold mb-2">{{ t("Plaatsing & Evaluatie") }}</h3>
          <p
            class="text-gray-700"
          >{{ t("Professionele begeleiding bij de start en regelmatige kwaliteitscontrole voor een duurzame samenwerking.") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
